import { Box } from '@mui/system';
import React, { useEffect, useRef } from 'react';
import { Calendar, CalendarProps } from '../calendar/calendar';
import { Grid, GridProps } from '../grid/grid';
import styles from './gantt.module.css';
import { TaskGanttContent, TaskGanttContentProps } from './task-gantt-content';

export type TaskGanttProps = {
  gridProps: GridProps;
  calendarProps: CalendarProps;
  barProps: TaskGanttContentProps;
  ganttHeight: number;
  scrollY: number;
  scrollX: number;
  timeEvents: { year: number; month: number };
};

export const TaskGantt: React.FC<TaskGanttProps> = ({
  gridProps,
  calendarProps,
  barProps,
  timeEvents,
  ganttHeight,
  scrollY,
  scrollX
}) => {
  const ganttSVGRef = useRef<SVGSVGElement>(null);
  const horizontalContainerRef = useRef<HTMLDivElement>(null);
  const verticalGanttContainerRef = useRef<HTMLDivElement>(null);
  const newBarProps = { ...barProps, svg: ganttSVGRef };

  useEffect(() => {
    if (horizontalContainerRef.current) {
      horizontalContainerRef.current.scrollTop = scrollY;
    }
  }, [scrollY]);

  useEffect(() => {
    if (verticalGanttContainerRef.current) {
      verticalGanttContainerRef.current.scrollLeft = scrollX;
    }
  }, [scrollX]);

  useEffect(() => {
    if (calendarProps.viewMode === 'Day') {
      const indexPoint = calendarProps.dateSetup.dates.findIndex(date => date.getMonth() === timeEvents.month);
      if (verticalGanttContainerRef.current) {
        verticalGanttContainerRef.current.scrollLeft = indexPoint * 69;
      }
    } else if (calendarProps.viewMode === 'Month') {
      const indexPoint = calendarProps.dateSetup.dates.findIndex(date => date.getMonth() === 0);
      if (verticalGanttContainerRef.current) {
        verticalGanttContainerRef.current.scrollLeft = indexPoint * 69;
      }
    }
  }, [timeEvents]);

  return (
    <div className={styles.ganttVerticalContainer} ref={verticalGanttContainerRef} dir="ltr">
      <Box className="stickyCal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={gridProps.svgWidth}
          height={calendarProps.headerHeight}
          fontFamily={barProps.fontFamily}
        >
          <Calendar {...calendarProps} />
        </svg>
      </Box>
      <div
        ref={horizontalContainerRef}
        className={styles.horizontalContainer}
        style={ganttHeight ? { height: ganttHeight, width: gridProps.svgWidth } : { width: gridProps.svgWidth }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={gridProps.svgWidth}
          height={barProps.rowHeight * barProps.tasks.length}
          fontFamily={barProps.fontFamily}
          ref={ganttSVGRef}
        >
          <Grid {...gridProps} />
          <TaskGanttContent {...newBarProps} />
        </svg>
      </div>
    </div>
  );
};
